import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Table } from '../../../components/elements';
import OrderDetails from './OrderDetails';

const ActivitySummary = () => {
  const [isActiveOrderDetailsModal, setIsActiveOrderDetailsModal] = useState(
    false,
  );
  return (
    <>
      <Table>
        <thead>
          <tr>
            <th>
              <div>
                <span>
                  <a onClick={() => {}}>
                    <i className="fas fa-sort-amount-down" />
                  </a>{' '}
                  Order Date
                </span>
              </div>
            </th>

            <th>
              <div>
                <span>
                  {/* <a onClick={() => {}}>
                    <i className="fas fa-sort-amount-down" />
                  </a> */}
                  Orders
                </span>
              </div>
            </th>

            <th>
              <div>
                <span>
                  {/* <a onClick={() => {}}>
                    <i className="fas fa-sort-amount-down" />
                  </a>{' '} */}
                  Delivery
                </span>
              </div>
            </th>

            <th>
              <div>
                <span>
                  {/* <a onClick={() => {}}>
                    <i className="fas fa-sort-amount-down" />
                  </a>{' '} */}
                  Sales
                </span>
              </div>
            </th>

            <th>
              <div>
                <span>
                  <a onClick={() => {}}>
                    <i className="fas fa-sort-amount-down" />
                  </a>{' '}
                  Payment
                </span>
              </div>
            </th>

            <th>
              <div>
                <span>
                  {/* <a onClick={() => {}}>
                    <i className="fas fa-sort-amount-down" />
                  </a>{' '} */}
                  Dinein
                </span>
              </div>
            </th>

            <th>
              <div>
                <span>
                  {/* <a onClick={() => {}}>
                    <i className="fas fa-sort-amount-down" />
                  </a>{' '} */}
                  Sales
                </span>
              </div>
            </th>

            <th>
              <div>
                <span>
                  {/* <a onClick={() => {}}>
                    <i className="fas fa-sort-amount-down" />
                  </a>{' '} */}
                  Total Sales
                </span>
              </div>
            </th>

            <th>
              <div>
                <span>
                  <a onClick={() => {}}>
                    <i className="fas fa-sort-amount-down" />
                  </a>{' '}
                  Payout
                </span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Link
                onClick={() => setIsActiveOrderDetailsModal(true)}
                style={{ color: '#00aeef' }}
              >
                25/03/2020
              </Link>
            </td>
            <td>9</td>
            <td>3</td>
            <td>$30.00</td>
            <td>3</td>
            <td>$30.00</td>
            <td>3</td>
            <td>$30.00</td>
            <td>$230.00</td>
          </tr>
        </tbody>
      </Table>
      <OrderDetails
        isActiveOrderDetailsModal={isActiveOrderDetailsModal}
        setIsActiveOrderDetailsModal={setIsActiveOrderDetailsModal}
      />
    </>
  );
};

export default ActivitySummary;
